import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "@tsp-core/store/utils";

import { SystemTypeId } from "../enums";
import { SystemTypesDictionary } from "../types";

type GetSystemTypesResponseData = {
  systemTypes: Array<{
    id: SystemTypeId;
    name: string;
    code: string;
    type: "internal" | "external";
    is_integrated: boolean;
    allowed_transfer_types: Array<SystemTypeId>;
    info: {
      prefered: boolean;
      info: string | Array<string> | null;
      limitations: string | Array<string> | null;
      detailsLink: string | null;
      description: string | null;
      paymentDuration?: string | null;
    } | null;
  } | null>;
};

export const systemTypesApi = createApi({
  reducerPath: "@system-types/api",
  baseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
  keepUnusedDataFor: 60 * 60 * 24,
  endpoints: (builder) => ({
    getSystemTypesDictionary: builder.query<SystemTypesDictionary, void>({
      query: () => ({
        url: "/getSystemTypes",
        method: "GET",
      }),
      transformResponse: (response: GetSystemTypesResponseData) => {
        return response.systemTypes.reduce((accumulator, item) => {
          if (!item) {
            return accumulator;
          }

          accumulator[item.id] = {
            id: item.id,
            name: item.name,
            code: item.code,
            type: item.type,
            isIntegrated: item.is_integrated,
            allowedTransferTypes: Object.values(item.allowed_transfer_types),
            info: item.info
              ? {
                  prefered: item.info.prefered,
                  info: item.info.info,
                  limitations: item.info.limitations,
                  detailsLink: item.info.detailsLink,
                  description: item.info.description,
                  paymentDuration: item.info.paymentDuration,
                }
              : null,
          };
          return accumulator;
        }, {} as SystemTypesDictionary);
      },
    }),
  }),
});
